import BaseForm from '@kakadu-dev/base-frontend-helpers/forms/BaseForm';
import DataProvider from '@kakadu-dev/base-frontend-helpers/helpers/DataProvider';
import { Product } from "../../models/Products";
import { ProductsApi } from "../../modules/products/api";
import { ProductsAttachmentsApi } from "../../modules/productsAttachments/api";
import { DispatchSelector, StateSelector } from "../../modules/selectors";
/**
 * Product images form
 */

export class ProductAttachmentsForm extends BaseForm {
  constructor(...args) {
    super(...args);
    this.modelClass = Product;
    this.imagesPreview = [];
    this.fields = [{
      label: 'Тип',
      name: 'type'
    }, {
      label: 'product ID',
      name: 'productId'
    }, {
      label: 'Изображения',
      name: 'attachment',
      type: BaseForm.TYPES.IMAGE,
      props: {
        web: {
          maxFiles: 20,
          previews: () => this.imagesPreview,
          // String or function
          postUrl: this.createImageUrl(ProductsApi.batchUpload, null, false),
          deleteUrl: this.createImageUrl(ProductsAttachmentsApi.delete),
          getSearchQuery: () => {
            return DataProvider.buildQuery().setQueryParam('type', this.defaultValues.type).setQueryParam('productId', this.defaultValues.productId);
          }
        }
      }
    }];
    this.dispatchUpdateForm = DispatchSelector.products.update;
    this.responseUpdateState = StateSelector.products.update;
  }

  /**
   * @inheritDoc
   */
  setDefault(field, value) {
    if (field === 'attachment') {
      this.imagesPreview.push(value);
      return this;
    }

    return super.setDefault(field, value);
  }

}